import { html } from 'lit';
import type { Purpose } from '@common/types/model.d.js';
import type { TefComs4p } from '@src/components/TefComs4p.js';
import { renderSinglePurposeConsents } from '@src/components/templates/occl/TefComs4p/singlePurposeEdit.tmpl.js';

//
// renders a single purpose block
//
// {Purpose name}
// {Purpose description}
//   {subscription BLOCK}
export const singlePurposeEdit = function render(this: TefComs4p, purpose : Purpose) {
  return html`
    <one-heading level="h6" variant="default">${purpose.title}</one-heading>
    <one-text as="p">
      ${purpose.shortDescription} ${this.getTemplateFn('tefPurposeDescriptionModal')(purpose)}
    </one-text>
    ${renderSinglePurposeConsents(this, purpose)}
  `;
};
